import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tangerinr"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 6.01353C12 6.01353 14.5559 5.25082 16 5.67556C18.8167 6.50402 20.9977 8.49776 21 13C21.0027 18.4881 17 20.9974 12 20.9974C7 20.9974 2.99963 18.4767 3 13C3.0003 8.50345 5.1128 6.50081 8 5.67556C9.44682 5.26202 12 6.01353 12 6.01353Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 6.01329C12 2.00026 7.25 3.25001 7.25 3.25001L12 6.01329Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.5618 5.4483L14.9963 3M11.9431 5.3C11.4064 2.15644 7.25 3.25001 7.25 3.25001L11.2036 5.55M12 6.01329C12 6.01329 9.44682 5.26178 8 5.67533C5.1128 6.50057 3.0003 8.50321 3 12.9998C2.99963 18.4765 7 20.9971 12 20.9971C17 20.9971 21.0027 18.4879 21 12.9998C20.9977 8.49752 18.8167 6.50378 16 5.67533C14.5559 5.25058 12 6.01329 12 6.01329Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M9 9.00391V9H9.00391V9.00391H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M7 12.0039V12H7.00391V12.0039H7Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M9 15.0039V15H9.00391V15.0039H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const Tangerinr = Vue.extend<IconProps>({
  name: 'TangerinrIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'tangerinr',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Tangerinr;
